export default __webpack_public_path__ + "static/media/Inter-UI-MediumItalic.5beb82d8.woff";